import { InMemoryCache } from '@apollo/client'
import { persistCache } from 'apollo3-cache-persist'

import localforage from 'lib/localforage'

const cache = new InMemoryCache()

export const waitOnCache = persistCache({
  cache,
  storage: localforage,
})
